import Button from '@doordash/component-button'

export const getButtonState = state => {
  if (state.isSubmitting) {
    return Button.States.Loading
  }
  if (state.isSubmitted) {
    return Button.States.Success
  }
  if (state.error) {
    return Button.States.Error
  }
  return Button.States.Default
}
